import { render, staticRenderFns } from "./update-order.vue?vue&type=template&id=2e064758"
import script from "./update-order.vue?vue&type=script&lang=js"
export * from "./update-order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports